define('home/views/ForumCardCollectionView',[
    'home/mixins/withItemRemovalSkipped',
    'home/mixins/withViewFeedTracking',

    'home/models/Session',

    'home/views/ForumCardView',
    'home/views/common/FetchableCollectionView',
], function (
    withItemRemovalSkipped,
    withViewFeedTracking,

    Session,

    ForumCardView,
    FetchableCollectionView
) {
    'use strict';

    /**
     * Shows a list of forum cards.
     * If list is empty, shows an empty state that includes the name of the user who
     * owns this list.
     *
     * Expects a collection of Forums or Channels with a link to their primaryForums.
     * Also expects a user option for the owner of this list.
     */
    var ForumCardCollectionView = FetchableCollectionView.extend({
        itemView: ForumCardView,
        className: 'cards',

        initialize: function () {
            FetchableCollectionView.prototype.initialize.apply(this, arguments);

            // ensure session user's following forums are fetched so that
            // following/followed buttons are displayed correctly
            var session = Session.get();
            session.loadPromise().then(function () {
                session.userProfile.forumsFollowing.ensureFetched();
            });
        },

        itemViewOptions: function (model) {
            // Collection may contain channels. Need to pass channel's
            // primary forum as the model of the ForumCardView
            if (model.primaryForum)
                return { model: model.primaryForum };
        },

        emptyViewOptions: function () {
            return { model: this.options.user };
        },
    });

    withItemRemovalSkipped.call(ForumCardCollectionView.prototype);
    withViewFeedTracking.call(ForumCardCollectionView.prototype);

    return ForumCardCollectionView;
});

